/**
 * Chat GraphQL queries and mutations.
 * createMetadataItem is used when the user clicks Create in chat to create a new file from AI-generated code.
 */

/**
 * Mutation to create a new metadata item (e.g. ApexClass, LightningComponentBundle, CustomField).
 * Uses organizationId + retrievalId from metadata v1 context.
 */
export const CREATE_METADATA_ITEM_MUTATION = `
  mutation CreateMetadataItem($input: CreateMetadataItemInput!) {
    createMetadataItem(input: $input) {
      message
      deployment {
        id
        status
      }
    }
  }
`;
